import { render } from "./GroupOverview.vue?vue&type=template&id=9d695bbc&scoped=true"
import script from "./GroupOverview.vue?vue&type=script&lang=js"
export * from "./GroupOverview.vue?vue&type=script&lang=js"

import "./GroupOverview.vue?vue&type=style&index=0&id=9d695bbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d695bbc"]])

export default __exports__